import React, { PureComponent } from "react";
import styled, { css } from "styled-components";
import PropTypes from "prop-types";
import { cssMainSelector } from "../lib/cssSelectors";

const Container = styled.div``;

const Legenda = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: ${p => p.theme.spacing.md};
    width: 100%;
  }
`;

const Title = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    font-weight: ${p => p.theme.font.weightBold};
    order: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

const convertedValuePadding = css `padding: ${p => p.theme.spacing.xs} ${p => p.theme.spacing.sm}`;
const ConvertedValue = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    background-color: ${p => p.theme.slider.valueBackgroundColor};
    color: ${p => p.theme.slider.valueColor};
    font-size: ${p => p.theme.font.sizeSm};
    font-weight: ${p => p.theme.font.weightSemiBold};
    ${convertedValuePadding};
    order: 1;
    white-space: nowrap;
  }
`;

const TopLabels = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    display: flex;
    flex-direction: row;
    font-size: ${p => p.theme.font.sizeXs};
    justify-content: space-between;
    padding-bottom: ${p => p.theme.spacing.none};
    width: 100%;
  }
`;

const MinTopLabel = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    order: 0;
  }
`;

const MaxTopLabel = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    order: 1;
  }
`;

const RangeSliderAndLabelWrapper = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    align-items: center;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`;

const MinSideLabel = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    order: 0;
    padding-right: ${p => p.theme.spacing.md};
  }
`;

const MaxSideLabel = styled.div`
  ${p => cssMainSelector(p.theme.tdsId)} {
    order: 2;
    padding-left: ${p => p.theme.spacing.md};
  }
`;

const RangeSlider = styled.input`
  ${p => cssMainSelector(p.theme.tdsId)} {
    appearance: none;
    background-color: transparent;
    order: 1;
    outline: none;
    padding: 10px 0;
    width: 100%;

    &:focus {
      outline: none;
    }

    &::-webkit-slider-runnable-track {
      width: 100%;
      height: 2px;
      cursor: pointer;
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
      background: ${p =>
        p.invertedColors ? p.theme.slider.fillColor : p.theme.slider.fillColor};
      border-radius: 0px;
      border: 0px solid ${p => p.theme.color.white};
    }

    &::-webkit-slider-thumb {
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
      border: 1px solid ${p => p.theme.slider.handleColor};
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background: ${p => p.theme.slider.handleColor};
      cursor: pointer;
      -webkit-appearance: none;
      margin-top: -6.5px;
    }

    &:focus::-webkit-slider-runnable-track {
      background: ${p =>
        p.invertedColors ? p.theme.slider.fillColor : p.theme.slider.fillColor};
    }

    &::-moz-focus-outer {
      border: 0;
    }

    &::-moz-range-track {
      width: 100%;
      height: 2px;
      cursor: pointer;
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
      background: ${p =>
        p.invertedColors ? p.theme.slider.fillColor : p.theme.slider.fillColor};
      border-radius: 0px;
      border: 0px solid ${p => p.theme.color.white};
    }

    &::-moz-range-thumb {
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
      border: 1px solid ${p => p.theme.slider.handleColor};
      height: 15px;
      width: 15px;
      border-radius: 50%;
      background: ${p => p.theme.slider.handleColor};
      cursor: pointer;
    }

    &::-ms-track {
      width: 100%;
      height: 2px;
      cursor: pointer;
      background: transparent;
      border-color: transparent;
      color: transparent;
    }

    &::-ms-fill-lower {
      background: ${p =>
        p.invertedColors
          ? p.theme.slider.backGroundColor
          : p.theme.slider.fillColor};
      border: 0px solid ${p => p.theme.color.white};
      border-radius: 0px;
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
    }

    &::-ms-fill-upper {
      background: ${p =>
        p.invertedColors
          ? p.theme.slider.fillColor
          : p.theme.slider.backGroundColor};
      border: 0px solid #ffffff;
      border-radius: 0px;
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
    }

    &::-ms-thumb {
      box-shadow: 0px 0px 0px ${p => p.theme.color.white},
        0px 0px 0px ${p => p.theme.color.white};
      border: 1px solid ${p => p.theme.slider.handleColor};
      height: 10px;
      width: 10px;
      border-radius: 50%;
      background: ${p => p.theme.slider.handleColor};
      cursor: pointer;
      margin-top: 0px;
    }

    &:focus::-ms-fill-lower {
      background: ${p =>
        p.invertedColors
          ? p.theme.slider.backGroundColor
          : p.theme.slider.fillColor};
    }

    &:focus::-ms-fill-upper {
      background: ${p =>
        p.invertedColors
          ? p.theme.slider.fillColor
          : p.theme.slider.backGroundColor};
    }
  }
`;

class Slider extends PureComponent {
  render() {
    const {
      invertedColors,
      labelPosition,
      labels,
      onChange,
      onChangeComplete,
      title,
      value
    } = this.props;

    return (
      <Container>
        <Legenda>
          <Title>{title}</Title>
          <ConvertedValue>{this.formattedConvertedValue()}</ConvertedValue>
        </Legenda>
        {labels.length > 0 &&
          labelPosition === "top" && (
            <TopLabels>
              <MinTopLabel>{labels[0]}</MinTopLabel>
              <MaxTopLabel>{labels[1]}</MaxTopLabel>
            </TopLabels>
          )}
        <RangeSliderAndLabelWrapper>
          {labels.length > 0 &&
            labelPosition === "side" && (
              <MinSideLabel>{labels[0]}</MinSideLabel>
            )}
          <RangeSlider
            type="range"
            invertedColors={invertedColors}
            min={this.minValue()}
            max={this.maxValue()}
            onChange={onChange}
            onMouseUp={onChangeComplete}
            onTouchEnd={onChangeComplete}
            value={value}
          />
          {labels.length > 0 &&
            labelPosition === "side" && (
              <MaxSideLabel>{labels[1]}</MaxSideLabel>
            )}
        </RangeSliderAndLabelWrapper>
      </Container>
    );
  }

  formattedConvertedValue() {
    const {
      convertedValueFunction,
      convertedValuePostfix,
      convertedValuePrefix
    } = this.props;

    if (convertedValueFunction != null) {
      return `${convertedValuePrefix}${convertedValueFunction(
        this.convertedValue()
      )}${convertedValuePostfix}`;
    } else {
      return `${convertedValuePrefix}${this.convertedValue()}${convertedValuePostfix}`;
    }
  }

  convertedValue() {
    const { value, valueMap } = this.props;

    if (valueMap != null && valueMap[value] != null) {
      return valueMap[value];
    } else {
      return value;
    }
  }

  maxValue() {
    const { max, valueMap } = this.props;

    if (valueMap != null) {
      let values = Object.keys(valueMap).map(Number);
      return Math.max(...values);
    } else {
      return max;
    }
  }

  minValue() {
    const { min, valueMap } = this.props;

    if (valueMap != null) {
      let values = Object.keys(valueMap).map(Number);
      return Math.min(...values);
    } else {
      return min;
    }
  }
}

Slider.propTypes = {
  convertedValuePostfix: PropTypes.string.isRequired,
  convertedValuePrefix: PropTypes.string.isRequired,
  invertedColors: PropTypes.bool.isRequired,
  labels: PropTypes.array,
  labelPosition: PropTypes.string,
  max: PropTypes.number.isRequired,
  min: PropTypes.number.isRequired,
  onChange: PropTypes.func,
  onChangeComplete: PropTypes.func,
  value: PropTypes.number.isRequired,
  valueMap: PropTypes.object
};

Slider.defaultProps = {
  convertedValuePostfix: "",
  convertedValuePrefix: "",
  invertedColors: false,
  labelPosition: "top",
  labels: [],
  max: 100,
  min: 0
};

export default Slider;
